import {
  buildMetasearchDiscountRequestKey,
  isMetasearchDiscountEnabled,
} from 'lib/metasearch/metasearchDiscountContext'
import {
  getMetasearchDiscountAmount,
  getIsMetasearchDiscountPending,
} from 'selectors/metasearchDiscountSelectors'
import { useAppSelector } from './reduxHooks'
import useMetasearchPriceId from './useMetasearchPriceId'
import { serialiseOccupancy } from 'lib/search/searchUtils'

interface Options {
  propertyId?: string
  checkIn?: string
  checkOut?: string
  rooms?: Array<App.Occupants>
  disabled?: boolean
}

export default function useMetasearchDiscount(
  price: number,
  options: Options = {},
): [number, boolean] {
  const gpid = useMetasearchPriceId()
  const enabled = isMetasearchDiscountEnabled()
  const discountEnabled = enabled && !options.disabled
  const occupancy = options.rooms ? serialiseOccupancy(options.rooms).join(',') : undefined
  const requestKey = discountEnabled && gpid && options.propertyId && options.checkIn && options.checkOut && price > 0 ?
      buildMetasearchDiscountRequestKey({
        token: gpid,
        propertyId: options.propertyId,
        checkIn: options.checkIn,
        checkOut: options.checkOut,
        occupancy,
        price,
      }) :
    undefined
  const selectorContext = {
    enabled: discountEnabled,
    requestKey,
  }

  const discountAmount = useAppSelector(state => getMetasearchDiscountAmount(state, selectorContext))
  const fetching = useAppSelector(state => getIsMetasearchDiscountPending(state, selectorContext))

  return [discountAmount, fetching]
}
